import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommunicationPreferencesService } from '../../../root/services/communication-preferences.service';
import { ActivatedRoute } from '@angular/router';
import { Observable, of } from 'rxjs';
import { CommsPreferencesGetDTO } from '../../model/communication-preferences-get.dto';
import { catchError } from 'rxjs/operators';
import { ToastService } from '../../services';
import { ITimeLine } from '../../model/timeline.dto';
import { TenantConfigService } from '../../../../../../../tenant-config/tenant-config.service';
import { commsPreferencesData } from '../../helpers/comms-preferences.data';

@Component({
  selector: 'hfc-contact-preferences-standalone',
  templateUrl: './contact-preferences-standalone.component.html',
  styleUrls: ['./contact-preferences-standalone.component.scss']
})
export class ContactPreferencesStandaloneComponent {
  @Input() isStandalone: boolean;
  @Input() timeLineContent: ITimeLine[];
  @Input() clientId?: string;
  @Output() nextAction = new EventEmitter<CommsPreferencesGetDTO>();

  public communicationPreferencesData$: Observable<CommsPreferencesGetDTO>;
  public tokenId: string;
  public latestPreferences: CommsPreferencesGetDTO;

  constructor(
    private readonly commsPreferencesService: CommunicationPreferencesService,
    private readonly route: ActivatedRoute,
    private readonly toastService: ToastService,
    private readonly tenantConfigService: TenantConfigService
  ) {
    this.tokenId = this.route.snapshot.queryParamMap.get('token');

    this.isStandalone === undefined ? (this.isStandalone = true) : (this.isStandalone = false);
    setTimeout(() => {
      if (this.isStandalone) {
        this.communicationPreferencesData$ = this.commsPreferencesService.getCommsPreferences(this.tokenId).pipe(
          catchError((error) => {
            this.toastService.add({ header: 'Preferences not found for token' }, 'error');
            return of(null);
          })
        );
      } else {
        this.communicationPreferencesData$ = of(this.defaultCommsPreferences());
      }
    }, 0);
  }

  /**
   * Seeds a new account's comms preferences: optional (non-essential)
   * contact updates start per the tenant's 'Optional Contact Updates
   * Defaults' setting — on for Heron, off for MAB tenants.
   */
  private defaultCommsPreferences() {
    const optionalUpdatesOn = this.tenantConfigService.optionalContactUpdatesDefaults;

    return {
      ...commsPreferencesData,
      commsPreferences: {
        ...commsPreferencesData.commsPreferences,
        mortgageMarketUpdateEmail: optionalUpdatesOn,
        nonEssentialEmail: optionalUpdatesOn,
        nonEssentialPhone: optionalUpdatesOn,
        nonEssentialWhatsapp: optionalUpdatesOn,
        nonEssentialPost: optionalUpdatesOn
      }
    };
  }

  onCommsPreferencesChanged(updatedPrefs: CommsPreferencesGetDTO): void {
    this.latestPreferences = updatedPrefs;
  }

  onConfirmCommsPreferences(): void {
    this.nextAction.emit(this.latestPreferences);
  }
}
